import { Component, ElementRef, Inject, Injector, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { CrudDataSource, CrudListComponent, ENVIRONMENT, Role, RoleService, ROLE_TYPE, UserStorage } from '@scisys-uim/uim-common';
import { RolesDataSource } from 'assets-service';



@Component({
  selector: 'app-role-search',
  templateUrl: './role-search.component.html',
  styleUrls: ['./role-search.component.scss']
})
export class RoleSearchComponent extends CrudListComponent<Role, string> {

  public searchForm: FormGroup;

  displayedColumns = ['name', 'description', 'ownPrivileges', 'nestedRoles', 'actions'];
  roles: Role[];
  nameFilter: string = '';


  @ViewChild('nameFilterInput', { static: true }) nameFilterInput: ElementRef;

  constructor(protected router: Router, protected userStorage: UserStorage, protected dialog: MatDialog, private roleService: RoleService, protected fb: FormBuilder, protected route: ActivatedRoute, protected injector: Injector,
    @Inject(ENVIRONMENT) protected environment: any) {
    super(ROLE_TYPE, route, router, userStorage, dialog, roleService, injector);

    this.searchForm = this.fb.group({
      name: [null]
    });
  }


  get dynamicPrivilegeRoles(): string[] {
    return this.environment?.dynamicPrivilegeRoles || [];
  }

  isDynamicPrivilegeRole(role: Role): boolean {
    return this.dynamicPrivilegeRoles.find(r => r == role.name) != null;
  }

  createServiceArguments() {
    return { nameFilter: this.nameFilter };
  }

  createDataSource(): CrudDataSource<Role> {
    return new RolesDataSource(this.roleService);
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.dataSource.data$.subscribe(
      data => {
        this.roles = data;
      });
  }

  ngAfterViewInit(): void {
    super.ngAfterViewInit();
    this.addSearchOnChangedInputEventListener(this.nameFilterInput);
  }

  allowsDelete(item: Role): boolean {
    return item.deletable;
  }

  allowsEdit(item: Role): boolean {
    return item.editable;
  }

  clearFilters() {
    this.nameFilter = null;
    this.loadPage();
  }

  backRoute() {
    return ['/admin'];
  }

}
